import React from 'react'

import { withTranslation as translate } from 'react-i18next'
import Error from './Error'

const errorMessageMappings = {
  missing: 'signup.profile.error.blank',
  passwords_must_match: 'signup.profile.error.password.passwords_must_match'
}

const Password = ({ password, passwordConfirmation, onChange, t, errors, inputRefs }) => {
  let passwordError
  let passwordConfirmationError
  if (errors.user && errors.user.password) {
    passwordError = <Error messageKey={errorMessageMappings[errors.user.password]} />
  }
  if (errors.user && errors.user.passwordConfirmation) {
    passwordConfirmationError = <Error messageKey={errorMessageMappings[errors.user.passwordConfirmation]} />
  }

  const handleInvalid = (event) => {
    if (event.target.name === 'passwordConfirmation') {
      setError('passwords_must_match')
      event.target.setCustomValidity(t(errorMessageMappings.passwords_must_match))
    }
  }

  const unsetError = () => {
    if (errors.user && errors.user.password_confirmation === 'passwords_must_match') {
      errors.user.password_confirmation = null
    }
  }

  const setError = (key) => {
    if (!errors.user) {
      errors.user = { password_confirmation: key }
    } else {
      errors.user.password_confirmation = key
    }
  }

  const verifyPassword = (event) => {
    if (event.target.name === 'passwordConfirmation') {
      event.target.setCustomValidity('')
      if (event.target.value !== password) {
        setError('confirmation')
        event.target.setCustomValidity(t(errorMessageMappings.passwords_must_match))
      } else {
        unsetError()
      }
    }
  }

  return (
    <>
      <div>
        <input
          className={passwordError ? 'error' : ''}
          name='password'
          type='password'
          ref={(input) => (inputRefs.password = input)}
          value={password}
          placeholder={t('signup.profile.password')}
          onChange={onChange}
          autoComplete='new-password'
          id='password'
        />
        {passwordError}
      </div>
      <div>
        <input
          className={passwordError ? 'error' : ''}
          name='passwordConfirmation'
          type='password'
          ref={(input) => (inputRefs.passwordConfirmation = input)}
          value={passwordConfirmation}
          placeholder={t('signup.profile.password_confirmation')}
          onChange={(e) => { verifyPassword(e); onChange(e) }}
          autoComplete='new-password'
          onInvalid={handleInvalid}
          id='password-confirmation'
        />
        {passwordConfirmationError}
      </div>
    </>
  )
}

export default translate()(Password)
